import { render, staticRenderFns } from "./base_home.vue?vue&type=template&id=391e6fc2&scoped=true&"
import script from "./base_home.vue?vue&type=script&lang=js&"
export * from "./base_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e6fc2",
  null
  
)

export default component.exports